<style scoped>
    .item {
        margin-bottom: 10px;
        width: 100%;
        text-align: left;
        display: block;
        padding-left: 6px;
        padding-right: 30px;
        box-sizing: border-box;
    }

    .item:last-of-type {
        margin-bottom: 0;
    }

    .showAll:hover {
        font-weight: bold;
        cursor: pointer;
    }

    .clearBtn {
        opacity: 0.3;
    }

    .clearBtn:hover {
        opacity: 1;
    }

    .opahover {
        opacity: 0.2;
    }

    .hover:hover {
        opacity: 1;
    }
</style>
<template>
    <div>
        <div v-if="editable">
            <Form ref="form" :rules="rules">
                <div v-for="(item,index) in current" :key="index">
                    <div style="display: flex;margin-bottom: 10px;align-items: center;">
                        <Select v-model="item.typeStr" @on-change="typeChanged(item,index)" style="width: 100px;margin-right: 10px;">
                            <Option v-for="(type,index) in types" :key="index" :value="type.name" :label="type.name" style="width: 100px;">
                                <span>{{type.name}}</span>
                            </Option>
                        </Select>
                        <FormItem :prop="'current['+index+'].label'">
                            <Input v-model="item.label" style="width:300px;margin-right: 10px;font-weight: bold;" placeholder="请输入标题">
                            </Input>
                        </FormItem>
                        <Checkbox v-model="item.required">必填</Checkbox>
                        <Icon type="md-remove-circle" class="hover opahover" style="color: red;font-weight: bold;font-size: 24px;margin-left: 50px;" @click="removeItem(index)" />
                        <Icon type="md-add-circle" class="hover opahover" style="color: #20bf64;font-weight: bold;font-size: 24px;margin-left: 10px;" @click="insertItem(index)" />
                    </div>
                    <div v-if="item.typeStr=='单选'||item.typeStr=='多选'">
                        <div v-for="(selection,j) in item.selections" :key="j" style="display: flex;align-items: center;margin-bottom: 10px;">
                            <FormItem :prop="'current['+index+'].selections['+j+'].name'">
                                <Input v-model="selection.name" style="width: 200px;margin-left: 110px;" placeholder="请输入选项" />
                            </FormItem>
                            <Icon type="md-remove-circle" class="hover opahover" style="color: red;font-weight: bold;font-size: 24px;margin-left: 20px;" @click="removeSelection(item,index,j)" />
                            <Icon type="md-add-circle" class="hover opahover" style="color: #20bf64;font-weight: bold;font-size: 24px;margin-left: 10px;" @click="insertSelection(item,index,j)" />
                        </div>
                        <div class="hover" style="color: #20bf64;font-weight: bold;display: block;" @click="addSelection(item,index)" v-if="item.selections.length==0">增加一个选项</div>
                    </div>
                    <div v-if="item.typeStr=='手机号'">
                        <div style="color: #aaa;margin-left: 110px;margin-top: -10px;margin-bottom: 10px;">用户填写该项时，必须填11位数字</div>
                    </div>
                </div>
                <div class="hover" style="color: #20bf64;font-weight: bold;width: 100px;" @click="addItem">增加一项字段</div>
            </Form>
        </div>
        <div v-else>

        </div>
    </div>
</template>
<script>
    export default {
        props: {
            current: {
                type: [Array],
                default: [],
            },
            max: {
                type: Number,
                default: null,
            },
            editable: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                showAll: false,
                loading: false,
                types: [
                    { name: '文字', value: 'text' },
                    { name: '单选', value: 'radio' },
                    { name: '多选', value: 'checkbox' },
                    { name: '手机号', value: 'phone' },
                ],
                rules: {},
                form: {},
            }
        },
        mounted() {
            // setTimeout(() => { this.init() }, 100)
            this.init()
        },
        methods: {
            init() {},
            confirm() {
                this.$emit('confirm', this.current)
            },
            typeChanged(item) {
                item.type = this.types.findOne({ name: item.typeStr })
                if ((item.type.value == 'radio' || item.type.value == 'checkbox') && (!item.selections || item.selections.length == 0)) {
                    item.selections = item.selections || []
                    if (item.selections.length == 0) {
                        this.addSelection(item, 0)
                    }
                }
            },
            addItem() {
                this.rules['current[' + this.current.length + '].label'] = [{ required: true, message: ' ', trigger: 'blur' }]
                this.current.push({ type: { name: '文字', value: 'text' }, typeStr: '文字', selections: [] })
            },
            removeItem(index) {
                delete this.rules['current[' + this.current.length + '].label']
                this.current.splice(index, 1)
            },
            insertItem(index) {
                this.rules['current[' + this.current.length + '].label'] = [{ required: true, message: ' ', trigger: 'blur' }]
                this.current.splice(index + 1, 0, { type: { name: '文字', value: 'text' }, typeStr: '文字', selections: [] })
            },
            addSelection(item, index) {
                this.rules['current[' + index + '].selections[' + item.selections.length + '].name'] = [{ required: true, message: ' ', trigger: 'blur' }]
                item.selections.push({ name: '' })
            },
            removeSelection(item, index, j) {
                delete this.rules['current[' + index + '].selections[' + item.selections.length + ']']
                item.selections.splice(j, 1)
            },
            insertSelection(item, index, j) {
                this.rules['current[' + index + '].selections[' + item.selections.length + '].name'] = [{ required: true, message: ' ', trigger: 'blur' }]
                item.selections.splice(j + 1, 0, { name: '' })
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/common/FormItemEditor.vue?583192bd